export default __webpack_public_path__ + "static/media/litho-templates-library-03.13b8a427.jpg";